import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface DeleteRequisitionResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function deleteRequisitionAction(requisitionId: string): Promise<ApiResponse<DeleteRequisitionResponse>> {
  return api.delete<ApiResponse<DeleteRequisitionResponse>>(`/requisitions/${requisitionId}`)
}
